import { filter } from 'lodash-es'

export const noProgramFound = (state) => state.programs.length === 0

export const hiddenPrograms = (state) =>
  state.programs ? filter(state.programs, 'is_hidden') : []
export const visiblePrograms = (state) =>
  state.programs.filter((lr) => lr.is_hidden === false)
